export default __webpack_public_path__ + "assets/search_icon.d35d870f.svg";